function loadState() {
  const serializedState = localStorage.getItem('state');
  if (serializedState === null) {
    return undefined;
  } else {
    return JSON.parse(serializedState);
  }
}

function saveState(state) {
  const serializedState = JSON.stringify(state);
  localStorage.setItem('state', serializedState);
}

function clearState() {
  localStorage.clear();
}

export { loadState, saveState, clearState };



// WEBPACK FOOTER //
// ./src/store/stateStorage.js